export default "__VITE_ASSET__sPohNJVv__"